import { render, staticRenderFns } from "./AbkLoader.vue?vue&type=template&id=030686b8&scoped=true&"
import script from "./AbkLoader.vue?vue&type=script&lang=js&"
export * from "./AbkLoader.vue?vue&type=script&lang=js&"
import style0 from "./AbkLoader.vue?vue&type=style&index=0&id=030686b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030686b8",
  null
  
)

export default component.exports